import moment from "moment";

export const RESTAURANT = {
  // value under which the remaining number of tables is displayed
  fewTables: 3,
  PEOPLE_OPTIONS: [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
    { label: "7", value: 7 },
    { label: "8", value: 8 },
    { label: "9", value: 9 },
    { label: "10", value: 10 },
  ],
  SERVICE_OPTIONS: ["breakfast", "lunch", "dinner"],
};

export const RESTAURANT_CONSTANTS = {
  DEFAULT_DATE: moment(new Date()),
  DEFAULT_PEOPLE: 1,
  DEFAULT_SERVICE: "lunch",
  DEFAULT_TIME: "12:30",
};

export const RESTAURANT_PEOPLE_SELECT_OPTIONS = [
  { label: "1", value: 1 },
  { label: "2", value: 2 },
  { label: "3", value: 3 },
  { label: "4", value: 4 },
  { label: "5", value: 5 },
  { label: "6", value: 6 },
  { label: "7", value: 7 },
  { label: "8", value: 8 },
  { label: "9", value: 9 },
  { label: "10", value: 10 },
];

export const serviceOptions = [
  { label: "PEQ.-ALMOÇO", value: "breakfast" },
  { label: "ALMOÇO", value: "lunch" },
  { label: "JANTAR", value: "dinner" },
];

export const serviceTime = [
  {
    name: "breakfast",
    preferredTime: "8:00",
    availableTime: ["7:30", "7:45", "8:00", "8:15", "8:30", "8:45", "9:00"],
  },
  {
    name: "lunch",
    availableTime: [
      "12:00",
      "12:30",
      "12:45",
      "13:00",
      "13:15",
      "13:30",
      "13:45",
      "14:00",
      "14:15",
      "14:30",
      "14:45",
      "15:00",
    ],
  },
  {
    name: "dinner",
    preferredTime: "20:00",
    availableTime: [
      "19:00",
      "19:30",
      "19:45",
      "20:00",
      "20:15",
      "20:30",
      "20:45",
      "21:00",
      "21:15",
      "21:30",
      "21:45",
      "22:00",
    ],
  },
];
